import "./agile-banner.scss";

import { EventAggregator, Subscription } from "aurelia-event-aggregator";
import { autoinject, customElement } from "aurelia-framework";
import * as moment from "moment";

import { UserLoaded } from "../../common/oidc/oidc-event-handler";
import { AuthService } from "../../services/auth-service";
import { UsersService } from "./../../services/users-service";

const ONE_SEC = 1000;

@autoinject
@customElement("agile-banner")
export class AgileBanner {
    private _ea: EventAggregator;
    private _subscription: Subscription;
    private readonly _authService: AuthService;
    private readonly _usersService: UsersService;
    public showAgileBanner: boolean = false;
    public agileUrl: string  = "https://www.axxess.com/agile/register?promo=AXXESSCLIENT";
    public days: string = "00";
    public hours: string = "00";
    public minutes: string = "00";
    public bannerExpiryDate: string = "05/04/2026";
    public intervalId: NodeJS.Timer = null;

    public constructor(authService: AuthService, usersService: UsersService, ea: EventAggregator) {
        this._authService = authService;
        this._ea = ea;
        this._usersService = usersService;
        this.initSubscriptions();
    }

    public attached() {
        this.handleBannerVisibility();
    }

    private initSubscriptions() {
        this._subscription = this._ea.subscribe(UserLoaded, () => this.loadUser());
    }

    private async loadUser() {
        let isLoggedIn = await this._authService.isLoggedIn();
        if (isLoggedIn) {
            this.handleBannerVisibility();
        }
    }

    public async handleBannerVisibility() {
        let today = moment();
        let mBannerExpiryDate = moment(this.bannerExpiryDate);
        let currentUser = await this._usersService.getCurrentUser();
        if (!currentUser.isSupportUser && moment(today).isBefore(mBannerExpiryDate)) {
            this.startTimer();
            setTimeout(() => {
                this.showAgileBanner = true;
            }, ONE_SEC);
        }
    }

    public startTimer() {
        this.intervalId = setInterval(() => {
            let today = moment();
            let mBannerExpiryDate = moment(this.bannerExpiryDate);
            if (moment(today).isAfter(mBannerExpiryDate)) {
                this.showAgileBanner = false;
                this.clearTimer();
            } else {
                let totalMinutes = mBannerExpiryDate.diff(today, "minutes");
                const totalHours = Math.floor(totalMinutes / 60);
                const days = Math.floor(totalHours / 24);
                const hours = totalHours % 24;
                const minutes = totalMinutes % 60;
                this.days = this.padZero(days);
                this.hours = this.padZero(hours);
                this.minutes = this.padZero(minutes);
            }
        }, ONE_SEC);
    }

    private padZero(value: number) {
        return value.toString().padStart(2, "0");
    }

    public clearTimer() {
        if (this.intervalId) {
            clearTimeout(this.intervalId);
        }
    }

    public redirectToAgilePage() {
        window.open(this.agileUrl);
    }

    public closeBanner() {
        this.showAgileBanner = false;
    }

    public detached() {
        this.clearTimer();
        this._subscription?.dispose();
    }
}